var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nearby-routes-wrap"},[_c('div',[_vm._v("附近的路線:")]),_c('div',_vm._l((_vm.routes),function(route,index){return _c('span',{key:index,staticClass:"nearby-routes"},[_c('router-link',{attrs:{"to":{
              name: 'routeinfo',
              params: {
                  id: route.routeid
              }
          }}},[_vm._v("\n              "+_vm._s(route.routec)+"\n          ")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }